import { forwardRef, type Ref, type SVGProps } from "react";
const IconPointerUpOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 30H3a1 1 0 0 1-.89-1.45l13-26a1 1 0 0 1 1.78 0l13 26A1 1 0 0 1 29 30M4.62 28h22.76L16 5.24z" />
  </svg>
);
const ForwardRef = forwardRef(IconPointerUpOutlineSVG);
ForwardRef.displayName = "IconPointerUpOutline";
export { ForwardRef as IconPointerUpOutline };
